import { useEffect } from "react";
import { kebabCase } from "lodash";
import { AppConfig } from "./appConfig";

export function useAppTheme(appConfig?: AppConfig) {
  useEffect(() => {
    if (!appConfig?.theme) return;

    const { theme } = appConfig;

    if (theme.colorScheme) {
      document.documentElement.style.setProperty(
        "color-scheme",
        theme.colorScheme,
      );
    }

    if (theme.fontSrcCss) {
      const link = document.createElement("link");
      link.href = theme.fontSrcCss;
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }

    if (theme.fontFamily) {
      document.documentElement.style.setProperty(
        "font-family",
        theme.fontFamily,
      );
    }

    const cssProps = Object.keys(theme).filter(
      (p) => p !== "fontSrcCss" && p !== "fontFamily",
    );

    cssProps.forEach((p) => {
      const val = theme[p as keyof typeof theme] || null;
      document.documentElement.style.setProperty(`--${kebabCase(p)}`, val);
    });

    return () => {
      if (theme.fontFamily) {
        document.documentElement.style.removeProperty("font-family");
      }
      cssProps.forEach((p) =>
        document.documentElement.style.removeProperty(`--${kebabCase(p)}`),
      );
    };
  }, [appConfig]);
}
